import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { onRenderLabelWithInstructions } from './onRenderLabelWithInstructions';
/**
 * This is a HOC that adds instructions after the label of a component.
 * We created this to work around Fluent's choice to put "instructions"
 * _after_ the field, rather than where most designs expect it to be:
 * between the label and the field itself.
 *
 * > Important, this _only_ works if the component has an `onRenderLabel`
 * > prop.
 */
export const WithInstructionsAfterLabel = (C) => (_a) => {
    var { instructions } = _a, props = __rest(_a, ["instructions"]);
    return (_jsx(C, Object.assign({}, props, { onRenderLabel: onRenderLabelWithInstructions(instructions) })));
};
